import { autoinject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';

@autoinject
export class ForgotPassword {

	private logger: Logger = LogManager.getLogger('FORGOTPASSWORDCONFIRMATION');

	async activate() {
		this.logger.debug("activate")
	}
}